import { X } from '@/ui/icons'
import { useEffect } from 'react'
import { cn } from '@/shared/utils'
import { useNotificationsPanel } from '@/contexts/NotificationsPanelContext'
import { NotificationsListContent } from './NotificationsListContent'

export function NotificationsPanel() {
  const { isOpen, closeNotificationsPanel } = useNotificationsPanel()

  useEffect(() => {
    if (!isOpen) return
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [isOpen])

  return (
    <>
      {/* Backdrop - mobile and desktop, click to close */}
      <div
        className={cn(
          'fixed inset-0 bg-foreground/20 backdrop-blur-[2px] z-40 transition-opacity duration-300',
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        )}
        onClick={closeNotificationsPanel}
        aria-hidden="true"
      />

      {/* Panel - match sidebar/app shell surface (earth-50) and ensure text uses semantic tokens for dark mode */}
      <div
        className={cn(
          'fixed left-0 top-0 h-full w-full max-w-[24rem] sm:w-[24rem] bg-earth-50 border-r border-earth-700 text-foreground shadow-lg z-50 flex flex-col transition-transform duration-300 ease-in-out',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
        role="dialog"
        aria-label="Notifications"
      >
        <div className="flex items-center justify-between p-4 border-b border-earth-700 flex-shrink-0">
          <h2 className="text-lg font-semibold text-foreground">Notifications</h2>
          <button
            onClick={closeNotificationsPanel}
            className="p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-earth-200 dark:hover:bg-earth-800 transition-colors"
            aria-label="Close panel"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 min-h-0 flex flex-col">
          <NotificationsListContent onActionClick={closeNotificationsPanel} />
        </div>
      </div>
    </>
  )
}
